import { useEffect, useState } from 'react';
import { clientConfig } from '../utilities/configService';
import TagManager from 'react-gtm-module'


export const useGoogleTagManager = () => {
    const [styleSheet, setStyleSheet] = useState('GTM not loaded');

    useEffect(() => {
        if (clientConfig) {
            const clientGTMID = clientConfig.GOOGLE_TAG_MANAGER_ID;
            const tagManagerArgs = { gtmId: clientGTMID };
            TagManager.initialize(tagManagerArgs);
        }
    }, []);

    return [styleSheet, setStyleSheet];
}